export const environment = {
  production: false,
  APIKey: '',
  gatewayBaseUrl: '',
};
